import clsx from 'clsx';
import { Heading, Text } from '@mysten/ui';
import type { ReactNode } from 'react';

import { Card } from '~/ui/Card';

export type CpcPageHeroProps = {
	title: ReactNode;
	subtitle?: ReactNode;
	/** 移动端补充说明（subtitle 在 sm 以下隐藏时可用） */
	mobileSubtitle?: ReactNode;
	actions?: ReactNode;
	className?: string;
};

/** 功能页内容区：与 DEX content 区一致的纵向间距 */
export const cpcPageContentClass = 'w-full space-y-4';

/** 功能页内容区块：与首页 / DEX 相同的 dark Card */
export function CpcSection({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<Card bg="dark" spacing="lg" className={className}>
			{children}
		</Card>
	);
}

export function CpcSectionTitle({
	children,
	className,
	trailing,
}: {
	children: ReactNode;
	className?: string;
	trailing?: ReactNode;
}) {
	if (trailing) {
		return (
			<div className={clsx('mb-4 flex items-center justify-between gap-3', className)}>
				<Heading variant="heading4/semibold" color="white">
					{children}
				</Heading>
				{trailing}
			</div>
		);
	}
	return (
		<Heading variant="heading4/semibold" color="white" className={clsx('mb-4', className)}>
			{children}
		</Heading>
	);
}

/** 与首页 Network Activity、DEX 行情条一致的页头 Card */
export function CpcPageHero({
	title,
	subtitle,
	mobileSubtitle,
	actions,
	className,
}: CpcPageHeroProps) {
	return (
		<Card bg="dark" spacing="lg" growOnHover className={className}>
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
				<div className="min-w-0 flex-1">
					<div className="flex flex-col gap-1">
						<Heading variant="heading4/semibold" color="white">
							{title}
						</Heading>
						{subtitle ? (
							<Text
								variant="subtitleSmall/medium"
								color="white"
								className={clsx('max-w-2xl !text-[#AEB9D0]', mobileSubtitle && 'hidden sm:block')}
							>
								{subtitle}
							</Text>
						) : null}
					</div>
				</div>
				{actions ? (
					<div className="flex shrink-0 flex-wrap items-center gap-2 sm:justify-end">
						{actions}
					</div>
				) : null}
			</div>
			{mobileSubtitle ? (
				<Text variant="bodySmall/medium" color="white" className="mt-3 !text-[#AEB9D0] sm:hidden">
					{mobileSubtitle}
				</Text>
			) : null}
		</Card>
	);
}
